import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgModule,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { slideInTopAnimation } from '../../../../../../utils/animations';
import { EstimatePlansTakeOffsStatesV2 } from '../../feat-estimate-plans-take-offs-v2/domain';
import { EstimateMeasurementCategoryVM, slideInTopParams } from '../feat-estimate-measurements-v2/domain';
import { EstimateMeasurementCategoryActionsModule } from '../ui-estimate-measurement-category-actions/estimate-measurement-category-actions.component';

@Component({
    selector: 'app-estimate-measurement-category',
    templateUrl: './estimate-measurement-category.component.html',
    styleUrls: ['./estimate-measurement-category.component.scss'],
    animations: [slideInTopAnimation],
    standalone: false,
})
export class EstimateMeasurementCategoryComponent implements OnChanges, OnInit, AfterViewInit {
    // @ts-ignore TS2564
    @Input() states: EstimatePlansTakeOffsStatesV2;
    // @ts-ignore TS2564
    @Input() measurementCategory: EstimateMeasurementCategoryVM;

    @Output() updateCategoryChanges = new EventEmitter<EstimateMeasurementCategoryVM>();
    @Output() deleteCategoryChanges = new EventEmitter<EstimateMeasurementCategoryVM>();
    @Output() toggleCategoryChanges = new EventEmitter<EstimateMeasurementCategoryVM>();
    @Output() toggleCategoryDragging = new EventEmitter<boolean>();

    // @ts-ignore TS2564
    @ViewChild('categoryDescription') private elDescription: ElementRef<HTMLElement>;
    // @ts-ignore TS2564
    public categoryForm: UntypedFormGroup;

    public isInvalidCategory = false;

    public readonly slideInTopParams = slideInTopParams['measurement-item'];

    constructor(private readonly formBuilder: UntypedFormBuilder) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.states?.currentValue) {
            this.updateCategoryStates();
        }
    }

    ngOnInit(): void {
        this.initCategoryForm();
        this.validateCategory();
    }

    private initCategoryForm() {
        this.categoryForm = this.formBuilder.group({
            description: [
                {
                    value: this.measurementCategory.description,
                    disabled: !this.states.canChangeMeasurements || this.states.isEstimateReadonly,
                },
                { validators: [Validators.required, Validators.maxLength(100)], updateOn: 'blur' },
            ],
        });

        // @ts-ignore TS2532
        this.categoryForm.controls.description.valueChanges.subscribe(() => this.onSubmitCategory());
    }

    ngAfterViewInit(): void {
        if (!this.measurementCategory.id) {
            setTimeout(() => {
                this.elDescription.nativeElement.focus();
            }, 0);
        }
    }

    private updateCategoryStates() {
        const controlDescription = this.categoryForm?.controls['description'];
        if (!controlDescription) {
            return;
        }

        if (controlDescription.enabled && (!this.states.canChangeMeasurements || this.states.isEstimateReadonly)) {
            controlDescription.disable({ emitEvent: false });
        } else if (controlDescription.disabled && this.states.canChangeMeasurements && !this.states.isEstimateReadonly) {
            controlDescription.enable({ emitEvent: false });
        }
    }

    private onSubmitCategory() {
        this.validateCategory();

        if (this.isInvalidCategory) {
            return;
        }

        this.updateCategoryChanges.emit({
            ...this.measurementCategory,
            // @ts-ignore TS2532
            description: this.categoryForm.controls.description.value,
        });
    }

    private validateCategory() {
        // @ts-ignore TS2532
        this.isInvalidCategory = this.categoryForm.controls.description.invalid;
    }

    public onDeleteCategory() {
        this.deleteCategoryChanges.emit({ ...this.measurementCategory, isDeleted: true });
    }

    public onToggleCategory() {
        this.toggleCategoryChanges.emit({ ...this.measurementCategory, isExpanded: !this.measurementCategory.isExpanded });
    }

    public toggleDrag(isEnabled: boolean) {
        this.toggleCategoryDragging.emit(isEnabled);
    }
}

@NgModule({
    declarations: [EstimateMeasurementCategoryComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule, EstimateMeasurementCategoryActionsModule],
    exports: [EstimateMeasurementCategoryComponent],
})
export class EstimateMeasurementCategoryModule {}
